// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1akqb","footer":"Form_footer__qduiM"};